

















export type ConferenceRecordingStatus = 'in-progress' | 'paused' | 'stopped' | 'processing' | 'completed' | 'absent';

export const ConferenceRecordingStatus = {
    InProgress: 'in-progress' as ConferenceRecordingStatus,
    Paused: 'paused' as ConferenceRecordingStatus,
    Stopped: 'stopped' as ConferenceRecordingStatus,
    Processing: 'processing' as ConferenceRecordingStatus,
    Completed: 'completed' as ConferenceRecordingStatus,
    Absent: 'absent' as ConferenceRecordingStatus
}
